module.exports = __webpack_public_path__ + "img/man.117971c.svg";